import { Divider, Paper, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import type { Currency, RevenueBreakdown } from '@weft/types';
import { Price } from '../../../../components/design/Price';

type DynamicInvoiceSummaryProps = {
  revenueBreakdown: RevenueBreakdown;
  currency: Currency;
};

export const DynamicInvoiceSummary: React.FC<DynamicInvoiceSummaryProps> = ({ revenueBreakdown, currency }) => {
  return (
    <Stack rowGap="16px">
      <Typography
        variant="body1"
        color="text.secondary"
        fontWeight={500}
      >
        Summary
      </Typography>
      <Paper sx={{
        padding: '20px 24px',
        borderRadius: '10px',
        rowGap: '16px',
        display: 'flex',
        flexDirection: 'column',
      }}
      >
        <Stack rowGap="8px">
          <Stack
            direction="row"
            alignItems="start"
            justifyContent="space-between"
          >
            <Typography variant="body1">Sub total</Typography>
            <Price
              variant="h6"
              currency={currency}
            >
              {revenueBreakdown.subtotal}
            </Price>
          </Stack>
          <Stack
            direction="row"
            alignItems="start"
            justifyContent="space-between"
          > 
            <Typography variant="body1">Discount</Typography>
            <Price
              variant="h6"
              currency={currency}
            >
              {-revenueBreakdown.discount}
            </Price>
          </Stack>

        </Stack>
        <Stack
          direction="row"
          alignItems="start"
          justifyContent="space-between"
        >
          <Typography variant="body1">Tax</Typography>
          <Price
            variant="h6"
            currency={currency}
          >
            {revenueBreakdown.tax}
          </Price>
        </Stack>
        {revenueBreakdown.creditsUsed > 0 && (
          <Stack
            direction="row"
            alignItems="start"
            justifyContent="space-between"
          > 
            <Typography variant="body1">Credits</Typography>
            <Price
              variant="h6"
              currency={currency}
            >
              {-revenueBreakdown.creditsUsed}
            </Price>
          </Stack>
        )}

        <Divider/>

        <Stack
          direction="row"
          alignItems="start"
          justifyContent="space-between"
        >
          <Typography variant="h6">Total</Typography>
          <Price
            variant="h4"
            currency={currency}
          >
            {revenueBreakdown.total}
          </Price>
        </Stack>
      </Paper>
    </Stack>
  );
};